import React from 'react';
import PropTypes from 'prop-types';

import RadioButton from './../FormComponents/RadioButtonItem';

import BookingSoftwares from './../../assets/AuthBookingSoftwares';

import './index.scss';

export default class SelectSoftware extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSoftware: this.props.softwares.selectedSoftware || 'MINDBODY',
      isOtherSoftware: false,
      otherBookingSoftware: '',
      isAlreadySaved: false,
    };

    this.onSoftwareChange = this.onSoftwareChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.renderSoftwareItem = this.renderSoftwareItem.bind(this);
    this.onNoSoftwareClick = this.onNoSoftwareClick.bind(this);
    this.onOtherBookingSoftwareChange = this.onOtherBookingSoftwareChange.bind(this);
  }

  componentWillMount() {
    this.setOtherSoftware(this.props);
  }

  componentWillReceiveProps(nextProps) {
    // Note: Do this only for other software
    this.setOtherSoftware(nextProps);

    if (this.props.softwares.selectedSoftware !== nextProps.softwares.selectedSoftware && nextProps.softwares.selectedSoftware && nextProps.softwares.selectedSoftware.length>0) {
      this.setState({
        selectedSoftware: nextProps.softwares.selectedSoftware,
      });
    }
  }

  onSoftwareChange(software) {
    this.setState({
      selectedSoftware: software.value,
      isOtherSoftware: false,
    });
  }

  onNoSoftwareClick(event) {
    event.preventDefault();

    this.setState({
      isOtherSoftware: true,
      selectedSoftware: null,
    });
  }

  onOtherBookingSoftwareChange(event) {
    this.setState({
      otherBookingSoftware: event.target.value,
    });
  }

  onNextButtonClick() {
    this.props.onNextClick();
    const software = this.state.isOtherSoftware
      ? this.state.otherBookingSoftware
      : this.state.selectedSoftware;

    // Save booking software in reducer
    this.props.selectSoftware({
      software,
      isIntegrated: !this.state.isOtherSoftware,
    });
  }

  setOtherSoftware(props) {
    if (!this.state.otherBookingSoftware && props.softwares.isOtherSoftware) {
      this.setState({
        isOtherSoftware: true,
        selectedSoftware: null,
        otherBookingSoftware: props.softwares.selectedSoftware,
        isAlreadySaved: true,
      });
    }
  }

  handleChange=(event)=>{
    this.setState({
      selectedSoftware: event.target.value,
      isOtherSoftware: false,
    });
  }

  renderSoftwareItem(item) {
    const onItemSelect = () => {
      this.onSoftwareChange(item);
    };

    let isDisabled = false;
    if (
      this.props.dashboard.tasksStatus.bookingSW_connect === 'completed' &&
      this.state.selectedSoftware !== item.value
    ) {
      isDisabled = true;
    }

    return (
      <div className="select-software__content__row" key={item.value}>
        <RadioButton
          onChange={onItemSelect}
          item={item}
          selected={this.state.selectedSoftware === item.value}
          disabled={isDisabled}
        />
        <div className="select-software__content__row__input">
          <span>{item.label}</span>
        </div>
      </div>
    );
  }
  getLabelForNonIntegrated=(value)=>{
    return value === 'SCIBLER'? 'NON API INTEGRATED': value;
  }
  render() {
    const bookingSoftwaresList = Object.keys(BookingSoftwares)
      .map((key) => {
        return BookingSoftwares[key];
      })
      .filter((item) => {
        return item.type.indexOf(this.props.currentDomain) !== -1;
      });

    const { selectedSoftware, isOtherSoftware, otherBookingSoftware } = this.state;
    const { softwares, dashboard } = this.props;
    const nextDisabled = !(selectedSoftware || (isOtherSoftware && otherBookingSoftware));
    const isSwConnected = dashboard.tasksStatus.bookingSW_connect === 'completed' || softwares?.info?.BOOKING_VENDOR_ID === 'SCIBLER';
    console.log('softwarese',softwares.info,isSwConnected);
    return (
      <div className="select-software">
        <p className="select-software__heading">What booking software does your business use?</p>
        {this.state.hasError ? (
          <div className="message message--error">Unable to set booking software</div>
        ) : (
          undefined
        )}
        <div className="select-software__content">
          {/* {bookingSoftwaresList.map(this.renderSoftwareItem)} */}
          <select className="input-software" value={this.state.selectedSoftware} onChange={this.handleChange} disabled={isSwConnected}>
            {bookingSoftwaresList.map(software=>{
            return <option value={software.value}>{this.getLabelForNonIntegrated(software.value)}</option>
            })}
          </select>
        </div>
        {!this.state.isOtherSoftware && !isSwConnected? (
          <div className="select-software__other">
            <a href="" onClick={this.onNoSoftwareClick}>
              Do you use a different booking software?
            </a>
          </div>
        ) : (
          undefined
        )}
        {this.state.isOtherSoftware ? (
          <div className="select-software__content__row">
            <input
              type="text"
              placeholder="Which booking software do you use?"
              onChange={this.onOtherBookingSoftwareChange}
              value={this.state.otherBookingSoftware}
            />
          </div>
        ) : (
          undefined
        )}
        <div className="select-software__actions">
          <button className="btn btn--secondary btn--lg" onClick={this.props.onBackClick}>
            Go Back
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={nextDisabled}
          >
            NEXT
          </button>
        </div>
      </div>
    );
  }
}

SelectSoftware.defaultProps = {
  currentDomain: '',
  selectSoftware: () => {},
  onBackClick: () => {},
};

SelectSoftware.propTypes = {
  currentDomain: PropTypes.string,
  selectSoftware: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape({
    selectedSoftware: PropTypes.string,
    isOtherSoftware: PropTypes.bool,
  }).isRequired,
  dashboard: PropTypes.shape({
    tasksStatus: PropTypes.shape({
      bookingSW_connect: PropTypes.string,
    }),
  }).isRequired,
};
